import React from 'react';


/*  jfd**********22.Nov.18.09:59*****
 *   Upgrading to React 18. From the docs
 *  https://reactjs.org/blog/2022/03/08/react-18-upgrade-guide.html
     ********************** `--===<>==<>==C>-< */
//Before
// import ReactDOM from 'react-dom';
//
// const rootEl = document.getElementById('app-site');
// After
import { createRoot } from 'react-dom/client';
const container = document.getElementById('app-site');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

//BEFORE
// Create a reusable render method that we can call more than once
// let render = () => {
//   // Dynamically import our main App component, and render it
//   const MainApp = require('./MainApp').default;
//   ReactDOM.render(
//       <MainApp/>,
//       rootEl
//   );
// };

//AFTER
// Create a reusable render method that we can call more than once
let render = () => {
  // Dynamically import our main App component, and render it
  const MainApp = require('./MainApp').default;
  root.render(
    <MainApp/>
  );
};

//BEFORE
// if (module.hot) {
//   module.hot.accept('./MainApp', () => {
//     const MainApp = require('./MainApp').default;
//     render(
//         <MainApp/>,
//         rootEl
//     );
//   });
// }

//AFTER
if (module.hot) {
  module.hot.accept('./MainApp', () => {
    const MainApp = require('./MainApp').default;
    render(
      <MainApp/>
    );
  });
}

render();
